import { cn } from '@tribeplatform/react-components/utils/cn'

export function VerticalDivider({ className }: { className?: string }) {
  return <div className={cn('w-px h-full bg-line-subdued', className)} />
}
